import { IAssetInput } from './asset-input.interface';

export interface IUpdateOrderCertificationWithAssets {
    orderCode: string;
    assets?: IAssetInput[];
    certificationStatus?: string;
    subStatus?: string;
    tripId?: string;
    checkpointIndex?: number;
}
